import { useContext } from 'react';
import AbstractStore from '../store/AbstractStore';
import RootStore from '../store/RootStore';
import { StoreContext } from '../store/StoreContext';
import { PickByType } from '../types/common-types';

export const useStore = (): PickByType<RootStore, AbstractStore> => {
  const store = useContext(StoreContext);
  if (!store) {
    throw new Error('useStore must be used within a StoreProvider');
  }
  return store as PickByType<RootStore, AbstractStore>;
};
